/* eslint-disable react/jsx-props-no-spreading */
import styled from "styled-components";
import { InputNumber as InputNumberAntd } from "antd";
import color from "../_style/color";
import device from "../_style/device";

const InputNumber = styled(InputNumberAntd)``;

const InputNumberContainer = styled.div`
  display: flex;
  border: 1px solid ${color.gainsboro};
  border-radius: 2px;
  justify-content: space-between;
  width: 160px;
  @media ${device.tablet} {
    margin: 0 15px;
  }

  .ant-input-number-focused,
  .ant-input-number:hover,
  .ant-input-number {
    border: none !important;
    box-shadow: none !important;
  }
  .ant-input-number-handler-wrap {
    opacity: 1;
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    border: none;
  }
  .ant-input-number-handler {
    background: #f5f6f7;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    width: 30px;
  }

  .ant-input-number-handler-up {
    position: absolute;
    left: 128px;
    border-left: 1px solid ${color.gainsboro};
    cursor: pointer;
    span {
      display: none !important;
    }
    ::before {
      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");
    }
  }

  .ant-input-number-handler-down {
    border: none;
    border-right: 1px solid ${color.gainsboro};
    span {
      display: none !important;
    }
    ::before {
      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");
    }
  }
  .ant-input-number-input {
    text-align: center;
  }

  .ant-input-number-handler-up:hover,
  .ant-input-number-handler-down,
  .ant-input-number-handler-down:hover,
  .ant-input-number-handler-up {
    height: 30px !important;
  }
`;

export { InputNumberContainer };
export default InputNumber;
